import PaymentMethods from 'app/models/payment_methods';

import Base from 'app/views/base';
import AccountBalanceView from 'app/views/account_balance_view';
import PaymentMethodDetailsView from 'app/views/payment_method_details_view';

import ChargeLogView from './charge_log';
import CashFlowView from './cash_flow';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'billing',

  initialize({ user }) {
    this.user = user;

    this.addSubview('accountBalance', '#account_balance', new AccountBalanceView({ model: this.user }));

    this.paymentMethods = new PaymentMethods({});
    this.addSubview('paymentMethods', '#payment_methods', new PaymentMethodDetailsView({
      model: this.paymentMethods, user: this.user
    }));

    this.addSubview('chargeLog', '#charge_log', new ChargeLogView({
      paymentMethods: this.paymentMethods,user: this.user
    }));

    this.addSubview('cashFlow', '#cash_flow', new CashFlowView({}));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/index.js